import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=06696203&scoped=true"
import script from "@/views/Groups/Tabs/Notes.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Tabs/Notes.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/Tabs/notes.scss?vue&type=style&index=0&id=06696203&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06696203",
  null
  
)

export default component.exports